import { FC } from 'react';
import styled from 'styled-components';
import { GenericContainerCard, SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match, WrestlerInMatch } from '../../../../types';

interface SpaceAvatarProps {
    withWinner: boolean;
    isWinner: boolean;
}

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

const AvatarWrestler = styled.div<SpaceAvatarProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80%;

    & img.avatar-wrestler {
        width: 60%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        // Se withWinner è true e se isWinner è true, bordo verde e 2px altrimenti bordo bianco e 1px
        border: ${props => props.withWinner ? props.isWinner ? '1.5px solid gold' : '1px solid white' : '1px solid white'};
    }
`;

const NameWrestler = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20%;
    font-size: 6px !important;
    font-weight: 500;
    color: white;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    padding: 0;
`;

interface SingleFileMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

const SingleFileMatchRender: FC<SingleFileMatchRenderProps> = ({ matchInfo, withWinner = false, isExpanded = false }) => {
    const wrestler1 = matchInfo.wrestlers[0];
    const wrestler2 = matchInfo.wrestlers[1];

    function renderWrestler(wrestler: WrestlerInMatch, side: 'left' | 'right') {
        return (
            <SpaceWrestler className={`space-wrestler ${side}`}>
                <AvatarWrestler
                 className='avatar-wrestler'
                 withWinner={withWinner}
                 isWinner={wrestler.pivot.is_winner}
                >
                    <img
                     src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path}
                     alt={wrestler.name}
                     className='avatar-wrestler'
                    />
                </AvatarWrestler>
                <NameWrestler className='name-wrestler'>{wrestler.name}</NameWrestler>
            </SpaceWrestler>
        )
    }

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard
             className='single-file-match-render'
             height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>
                    {renderWrestler(wrestler1, 'left')}
                </SideSpace>
                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Single' />
                <SideSpace className='side-space'>
                    {renderWrestler(wrestler2, 'right')}
                </SideSpace>

            </GenericContainerCard>
        )
    }

    return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default SingleFileMatchRender;
